"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationErrorMessage = exports.getDayStatus = exports.getButtonText = exports.ECalendarValidationError = void 0;
exports.processDaysAvailability = processDaysAvailability;
var _dateFns = require("date-fns");
const MAX_DAYS = 30;
function processDaysAvailability(availabilityArray, from, to) {
  const today = new Date();

  /**
   * Эта часть кода срабатывает в случае когда выбрана только первая дата.
   * Тогда мы хотим подсветить для пользователя НЕ все доступные даты в календаре,
   * а только ближайший к выбранной дате неприрывный диапазон доступных дней.
   * */
  if (from && !to) {
    const fromIndex = (0, _dateFns.differenceInCalendarDays)(from, today);
    let availableRangeStart = 0;
    let availableRangeEnd = availabilityArray.length - 1;
    for (let i = 0; i < availabilityArray.length; i++) {
      if (i < fromIndex && availabilityArray[i] === 0) {
        availableRangeStart = i + 1;
      }
      if (i >= fromIndex && availabilityArray[i] === 0) {
        availableRangeEnd = i;
        break;
      }
    }
    return availabilityArray.map((_, i) => i >= availableRangeStart && i <= availableRangeEnd ? 1 : 0);
  }

  /**
   * Каждая первая дата в занятых диапозонах это дата в которую гости заезжают.
   * Но эта дата может быть выбрана как дата выезда другого гостя, поэтому она не заблокирована для выбора.
   * Соответственно этот день будет иметь статус "только выезд", а остальные занято/свободно
   * 2 - только выезд
   */
  return availabilityArray.map((value, i) => value === 0 && availabilityArray[i - 1] === 1 ? 2 : value);
}
const getDayStatus = (availabilityArray, date) => {
  const today = new Date();
  const currentDateIndex = (0, _dateFns.differenceInCalendarDays)(date, today);

  /**
   * Даты раньше "сегодня" недоступны
   */
  if (currentDateIndex < 0) {
    return 0;
  }

  /** Если календарь проверяет даты за пределами проверенных на доступность, возвращать их доступными */
  if (availabilityArray[currentDateIndex] === undefined || currentDateIndex < 0) {
    return 1;
  }

  // 0 – занято, 1 – свободно, 2 - только выезд
  return availabilityArray[currentDateIndex];
};
exports.getDayStatus = getDayStatus;
let ECalendarValidationError = exports.ECalendarValidationError = /*#__PURE__*/function (ECalendarValidationError) {
  ECalendarValidationError["NO_RANGE"] = "noRange";
  ECalendarValidationError["MIN_RANGE"] = "minRange";
  ECalendarValidationError["MAX_RANGE"] = "maxRange";
  ECalendarValidationError["ONLY_CHECKOUT"] = "onlyCheckout";
  return ECalendarValidationError;
}({});
const ValidationRulesErrorMap = {
  [ECalendarValidationError.NO_RANGE]: 'Даты не выбраны',
  [ECalendarValidationError.MIN_RANGE]: 'Выберите разные дни заезда и выезда',
  [ECalendarValidationError.MAX_RANGE]: 'Максимум 30 ночей',
  [ECalendarValidationError.ONLY_CHECKOUT]: 'Доступен только выезд'
};

// Тут важен порядок тк одновременно может быть показано только одно сообщение, будет показано первое найденое
const validationRules = [[ECalendarValidationError.NO_RANGE, selection => {
  const {
    startDate,
    endDate
  } = selection;
  return !!startDate || !!endDate;
}], [ECalendarValidationError.ONLY_CHECKOUT, selection => {
  const {
    startDate,
    daysAvailability
  } = selection;
  if (!startDate) {
    return false;
  }
  const index = (0, _dateFns.differenceInCalendarDays)(startDate, new Date());

  // Каждая первая дата в занятых диапозонах это дата в которую гости заезжают.
  // Но эта дата может быть выбрана как дата выезда другого гостя, поэтому она не заблокирована для выбора.
  // Однако выбор ее первой датой является некорректным.
  return !!daysAvailability[index];
}], [ECalendarValidationError.MIN_RANGE, selection => {
  const {
    startDate,
    endDate
  } = selection;
  if (!startDate || !endDate) {
    return false;
  }
  return Math.abs((0, _dateFns.differenceInCalendarDays)(startDate, endDate)) > 0;
}], [ECalendarValidationError.MAX_RANGE, selection => {
  const {
    startDate,
    endDate
  } = selection;
  if (!startDate || !endDate) {
    return false;
  }
  return Math.abs((0, _dateFns.differenceInCalendarDays)(startDate, endDate)) <= MAX_DAYS;
}]];
const getValidationErrorMessage = selection => {
  const invalidRule = validationRules.find(_ref => {
    let [, predicate] = _ref;
    return !predicate(selection);
  });
  if (!invalidRule) {
    return [undefined, ''];
  }
  return [invalidRule[0], ValidationRulesErrorMap[invalidRule[0]]];
};
exports.getValidationErrorMessage = getValidationErrorMessage;
const getButtonText = (firstDateSelected, rangeSelected) => {
  if (rangeSelected) {
    return 'Готово';
  } else if (firstDateSelected) {
    return 'Выберите дату выезда';
  }
  return 'Выберите даты';
};
exports.getButtonText = getButtonText;